<template>
  <InfoTooltip class="ml-1.5">
    <I18n v-if="user" :message="discount ? t['w.module.product.prices_tooltiploggedin.discount'] : t['w.module.product.prices_tooltiploggedin.regular']">
      <template #memberDiscountCreditAmount>
        <strong>{{ usePriceHtml(user.balance) }}</strong>
      </template>
      <template #price>{{ usePriceHtml(price) }}</template>
      <template #discountPercentage>
        <strong>{{ discountPercentage.toLocaleString('et-EE') }}%</strong>
      </template>
      <template #discountAmount>{{ usePriceHtml(discountAmount) }}</template>
      <template #finalPrice>
        <strong>{{ usePriceHtml(finalPrice) }}</strong>
      </template>
    </I18n>
    <template v-else>{{ t['w.module.product.prices_tooltiploggedout']() }}</template>
  </InfoTooltip>
</template>

<script setup lang="ts">
import InfoTooltip from '~/components/info-tooltip/InfoTooltip.vue'
import * as t from '~/messages'
import I18n from '~/components/i18n/I18n.vue'
import { usePriceHtml } from '~/composables/price'

const user = useUserState()

const props = defineProps<{
  price: number
  discount: boolean
  bestPossiblePrice: number
}>()

const discountAmount = computed(() => {
  if (!user.value) {
    return 0
  }

  return Math.min(user.value.balance, props.price - props.bestPossiblePrice)
})
const discountPercentage = computed(() => Math.floor((discountAmount.value / props.price) * 1000) / 10)
const finalPrice = computed(() => props.price - discountAmount.value)
</script>
